import { render, staticRenderFns } from "./app-checkbox.vue?vue&type=template&id=370956fb&scoped=true&"
import script from "./app-checkbox.vue?vue&type=script&lang=js&"
export * from "./app-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./app-checkbox.vue?vue&type=style&index=0&id=370956fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370956fb",
  null
  
)

export default component.exports